export default __webpack_public_path__ + "static/media/Monger-HUD-00.a9799f5f.jpg";